import { Button } from 'semantic-ui-react';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import 'Styles/components/datePickerCustomButton.less';

class DatePickerCustomButton extends Component {
  render() {
    const {
      onClick,
      isDisabled,
      value,
      style = {},
      onFocus,
      onBlur,
      className,
      ...rest
    } = this.props;
    return (
      <Button
        {...rest}
        className={classnames('datepicker--custom--button', className)}
        type={'button'}
        onClick={onClick}
        disabled={isDisabled}
        style={style}
      >
        {value}
      </Button>
    );
  }
}

DatePickerCustomButton.propTypes = {
  onClick: PropTypes.func,
  isDisabled: PropTypes.bool,
  value: PropTypes.string,
  style: PropTypes.object,
};
export { DatePickerCustomButton };



// WEBPACK FOOTER //
// ./src/components/datepickerCustomButton/DatePickerCustomButton.js